import { createMiddleware } from '@tanstack/react-start';

import { getSessionCookie } from '@/utils/session';

export const sessionMiddleware = createMiddleware().server(async ({ request, next }) => {
  const session = getSessionCookie(request);

  return next({ context: { session } });
});
